const DATA_URL =
  'https://raw.githubusercontent.com/cosminpm/tft-double-up/main/data/current.json'

export async function fetchAllData() {
  const res = await fetch(DATA_URL, { cache: 'no-cache' })
  if (!res.ok) throw new Error('Failed to fetch data')
  return res.json()
}
